<script>
	export let initialGraph;

	import Viewer from './Viewer.svelte';
	import Editor from './Editor.svelte';
	import Player from './Player.svelte';


	let graph = initialGraph;

	let view = 'viewer'


	function handleEdit() {
		view = 'editor';
	}

	function handleChange(e) {
		graph = e.detail.json;
		view = 'viewer';
	}
</script>


<main>
	{#if false }
		<button on:click={handleEdit}>
			Edit
		</button>
	{/if}

	{#if view == 'viewer'}
		<Viewer graph={graph} />
	{/if}	
	{#if view == 'editor'}
		<Editor graph={graph} on:change={handleChange} />
	{/if}	
</main>

<style>
	html, body {
		padding:0;
		margin: 0;
		box-sizing: border-box;
	}
</style>